import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';

const Customer1SaleBatchDetailsModal = ({ batch, show, onHide }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user, token } = useAuth();

  useEffect(() => {
    if (!batch || !batch.SellBatchID) return;
    const fetchItems = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await fetch(`/api/customer1-sales/batch-details/${batch.SellBatchID}`, {
          headers: {
            'Content-Type': 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
            'x-owner-id': user?.ownerId || user?.id || '',
            'x-staff-id': user?.staffId || ''
          }
        });
        if (!res.ok) throw new Error('Server error');
        const data = await res.json();
        setItems(Array.isArray(data) ? data : []);
      } catch (err) {
        setError(err.message);
        setItems([]);
      } finally {
        setLoading(false);
      }
    };
    fetchItems();
  }, [batch]);

  // Don't render modal if no batch is selected
  if (!batch) {
    return null;
  }

  const saleCurrency = items[0]?.Currency || batch?.Currency || 'UZS';
  const saleTotal = items.reduce((sum, it) => sum + Number(it.QuantitySold || 0) * Number(it.SalePricePerUnit || 0), 0);
  const deliveryPrice = batch?.isdelivery ? Number(batch.delivery_price || 0) : 0;
  const grandTotal = saleTotal + deliveryPrice;

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Sotuv Partiyasi Tafsilotlari (ID: {batch.SellBatchID})</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center py-4">Yuklanmoqda...</div>
        ) : error ? (
          <div className="text-center text-danger py-4">Xatolik: {error}</div>
        ) : items.length === 0 ? (
          <div className="text-center py-4">Hech qanday mahsulot topilmadi</div>
        ) : (
          <>
            <div className="mb-3 p-3 bg-light border rounded d-flex flex-wrap gap-3 justify-content-between">
              <div><strong>Jami narx:</strong> {saleTotal.toLocaleString()} {saleCurrency}</div>
              <div><strong>Yetkazib berish narxi:</strong> {deliveryPrice.toLocaleString()} {saleCurrency}</div>
              <div><strong>Umumiy:</strong> {(grandTotal).toLocaleString()} {saleCurrency}</div>
            </div>
            <div className="table-responsive">
              <table className="table table-bordered table-striped">
                <thead className="table-dark">
                  <tr>
                    <th>Mahsulot Nomi</th>
                    <th>Soni</th>
                    <th>Narxi (birlik)</th>
                    <th>Sana</th>
                    <th>Shtrix-kod</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((item, idx) => (
                    <tr key={item.SaleID || idx}>
                      <td>{item.product_name || '-'}</td>
                      <td className="text-center">{item.QuantitySold}</td>
                      <td className="text-end">
                        {Number(item.SalePricePerUnit).toLocaleString()} {item.Currency}
                      </td>
                      <td className="text-center">
                        {item.SaleDate ? new Date(item.SaleDate).toLocaleDateString('uz-UZ') : '-'}
                      </td>
                      <td className="text-center">{item.barcode || '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Yopish
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default Customer1SaleBatchDetailsModal; 